export const LOADING = "GETTING_PLACES";
export const ERROR = "PLACES_ERROR";
export const CREATE_PLACE = "CREATE_PLACE";
export const DELETE_PLACE = "DELETE_PLACE";
export const GET_PLACES = "GET_PLACES";
export const EDIT_PLACES = "EDIT_PLACES";
export const GET_SINGLE_PLACE = "EDIT_PLACE";
